import * as Types from '@trello/graphql/generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {"context":{"operationName":"BoardTableViewMember"}}
export type BoardTableViewMemberQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BoardTableViewMemberQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'idEnterprisesAdmin' | 'memberType' | 'idPremOrgsAdmin'>
    & { prefs?: Types.Maybe<(
      { __typename: 'Member_Prefs' }
      & Pick<Types.Member_Prefs, 'colorBlind'>
    )> }
  )> }
);


export const BoardTableViewMemberDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardTableViewMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idEnterprisesAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"memberType"}},{"kind":"Field","name":{"kind":"Name","value":"idPremOrgsAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colorBlind"}}]}}]}}]}}]};

/**
 * __useBoardTableViewMemberQuery__
 *
 * To run a query within a React component, call `useBoardTableViewMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoardTableViewMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoardTableViewMemberQuery({
 *   variables: {
 *   },
 * });
 */
export function useBoardTableViewMemberQuery(baseOptions?: Apollo.QueryHookOptions<BoardTableViewMemberQuery, BoardTableViewMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BoardTableViewMemberQuery, BoardTableViewMemberQueryVariables>(BoardTableViewMemberDocument, options);
      }
export function useBoardTableViewMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BoardTableViewMemberQuery, BoardTableViewMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BoardTableViewMemberQuery, BoardTableViewMemberQueryVariables>(BoardTableViewMemberDocument, options);
        }
export type BoardTableViewMemberQueryHookResult = ReturnType<typeof useBoardTableViewMemberQuery>;
export type BoardTableViewMemberLazyQueryHookResult = ReturnType<typeof useBoardTableViewMemberLazyQuery>;
export type BoardTableViewMemberQueryResult = Apollo.QueryResult<BoardTableViewMemberQuery, BoardTableViewMemberQueryVariables>;